// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WM-z","isFullWidth":"XM-z","landingPageVideo":"YM-z","play":"ZM-z","iframeVideo":"_M-z","playHidden":"aN-z","fullwidth":"bN-z"};